<div class="modal-header">
  <h4 class="modal-title">
    {{ 'elbridge.send.title' | translate }}
  </h4>
  <button aria-label="Close"
          class="close pull-right"
          type="button"
          (click)="close()"><span aria-hidden="true">×</span></button>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p [innerHTML]="'elbridge.info.label' | translate"></p>
    <p>
      <a class='green u-hover'
      href="javascript:void(0)" (click)="openInfoLink()">{{'elbridge.info.link.title' | translate}}</a>
    </p>
  </div>
</div>

<div class="modal-footer" >
  <button class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.close' | translate}}
  </button>
  <button class="btn btn-primary btn-forward"
          type="submit"
          (click)="submit()">
    {{'header.menu.elbridge_start' | translate}}
  </button>
</div>
